import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { iconSize } from '@guardian/source-foundations';
import type { IconProps } from './types';

export const SvgArrowDownStraight = ({
	size,
}: IconProps): EmotionJSX.Element => (
	<svg
		viewBox="0 0 30 30"
		xmlns="http://www.w3.org/2000/svg"
		width={size ? iconSize[size] : undefined}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.95 4v19.125l-8.975-7.5L4 16.6l10.45 10.425h1L25.9 16.6l-.975-.975-8.975 7.5V4h-2z"
		/>
	</svg>
);
